import { ENU_COURSE_TYPE } from '@/utils/course';
import { ICourseChapter, ICourseLesson } from './type';
import { ICourseDetail } from '@/pages/courseDetail/utils/type';

// 根据课程类型，获取章节数据
const getCourseChapterDtos = (courseDetail: ICourseDetail): ICourseChapter[] => {
  const { type, videoCourseChapterDtos } = courseDetail;

  switch (type) {
    case ENU_COURSE_TYPE.VIDEO:
      return videoCourseChapterDtos;
    default:
      return [];
  }
};

/**
 * 处理章节列表鉴权
 * @param courseDetail 课程详情
 */
export const processChapterListAuth = (courseDetail: ICourseDetail): ICourseChapter[] => {
  const originChapterList = getCourseChapterDtos(courseDetail);
  if (!originChapterList?.length) return [];

  const { hadBuyed, fixedPrice } = courseDetail;
  // 免费或者已经购买
  const freeOrBuyed = fixedPrice <= 0 || !!hadBuyed;
  // 付费课程，未购买
  const notFreeAndNotBuyed = fixedPrice > 0 && !hadBuyed;

  return originChapterList.map((chapter) => {
    return {
      ...chapter,
      children: (chapter.children || []).map((lesson) => {
        const isPreview = lesson.preview === 1;
        return {
          ...lesson,
          canPlay: freeOrBuyed || isPreview,
          hasLocked: notFreeAndNotBuyed && !isPreview,
          hasPreview: notFreeAndNotBuyed && isPreview,
        };
      }),
    };
  });
};

/**
 * 获取所有课时
 */
export const getLessonList = (chapterList: ICourseChapter[]) => {
  return chapterList.reduce((pre, cur) => {
    if (cur?.children?.length) {
      pre.push(...cur.children);
    }
    return pre;
  }, [] as ICourseLesson[]);
};

/**
 * 获取选中的课时信息
 * @params chapterList 章节列表
 * @params chapterId 章节id
 */
export const getSelectedLessonInfo = (chapterList: ICourseChapter[], chapterId?: string | number) => {
  if (!chapterList?.length) return null;
  const defaultLeason = chapterList[0].children[0];
  if (!chapterId) {
    return defaultLeason;
  }
  return getLessonList(chapterList).find((item) => item.id === Number(chapterId)) || defaultLeason;
};
